import { advancedFilterOperators } from '../../enums/dropdownHelpers/advancedFilterOperators';
import fieldsValidationRules from '../../utils/fieldsValidationRules';
import { FieldDataTypes } from '../../enums/fieldDataTypes';
import { filterOperators } from '../../enums/filterOperators';
import moment from 'moment';

export default {
	computed: {
		validations() {
			return fieldsValidationRules;
		},
		disableOperators() {
			if (this.selectedFieldId) return false;
			return true;
		},
		disableValue() {
			if (this.selectedOperator) return false;
			return true;
		},
		operatorRule() {
			if (this.selectedFieldId)
				return [this.validations.ruleRequired(this.selectedOperator)];
			return [];
		},
		selectedColumn() {
			if (!this.filter) return null;
			if (!this.columns) return null;
			if (!this.selectedFieldId) return null;
			var col = this.columns.find((x) => x.Id == this.selectedFieldId);
			if (!col) return null;
			return JSON.parse(JSON.stringify(col));
		},

		filterHasValue() {
			if (!this.selectedColumn) return false;

			let differentValueControl = [
				FieldDataTypes.BOOLEAN,
				FieldDataTypes.AUTOGENERATED_BOOLEAN,
				FieldDataTypes.DATETIME,
				FieldDataTypes.DATE,
				FieldDataTypes.AUTOGENERATED_DATETIME,
				FieldDataTypes.APPROVAL_STATUS,
			];
			if (
				differentValueControl.includes(
					this.selectedColumn.DataField.DataType
				)
			) {
				return false;
			}

			if (!this.selectedOperator) return false;
			if (
				this.selectedOperator != filterOperators.IsBlank &&
				this.selectedOperator != filterOperators.IsNotBlank
			) {
				return true;
			}
			return false;
		},

		filterHasDateValue() {
			if (!this.selectedColumn) return false;
			if (!this.selectedOperator) return false;
			if (this.selectedColumn.DataField.DataType == FieldDataTypes.DATE) {
				if (
					this.selectedOperator != filterOperators.IsBlank &&
					this.selectedOperator != filterOperators.IsNotBlank
				) {
					return true;
				}
			}
			return false;
		},
		filterHasDateTimeValue() {
			if (!this.selectedColumn) return false;
			if (!this.selectedOperator) return false;
			if (
				this.selectedColumn.DataField.DataType ==
					FieldDataTypes.DATETIME ||
				this.selectedColumn.DataField.DataType ==
					FieldDataTypes.AUTOGENERATED_DATETIME
			) {
				if (
					this.selectedOperator != filterOperators.IsBlank &&
					this.selectedOperator != filterOperators.IsNotBlank
				) {
					return true;
				}
			}
			return false;
		},
		filterHasBooleanValue() {
			if (!this.selectedColumn) return false;
			if (!this.selectedOperator) return false;
			if (
				this.selectedColumn.DataField.DataType ==
					FieldDataTypes.BOOLEAN ||
				this.selectedColumn.DataField.DataType ==
					FieldDataTypes.AUTOGENERATED_BOOLEAN
			) {
				if (!this.selectedOperator) return false;
				if (
					this.selectedOperator != filterOperators.IsBlank &&
					this.selectedOperator != filterOperators.IsNotBlank
				) {
					return true;
				}
			}
			return false;
		},
		filterHasApprovalStatusValue() {
			if (!this.selectedColumn) return false;
			if (!this.selectedOperator) return false;
			if (
				this.selectedColumn.DataField.DataType ==
				FieldDataTypes.APPROVAL_STATUS
			) {
				if (
					this.selectedOperator != filterOperators.IsBlank &&
					this.selectedOperator != filterOperators.IsNotBlank
				) {
					return true;
				}
			}
			return false;
		},

		operators() {
			if (!this.selectedColumn) return [];
			let allowedOperators = [];

			let dataType = this.selectedColumn.DataField.DataType;
			if (this.selectedColumn.ReferenceListType) {
				dataType = FieldDataTypes.TEXT;
			}
			switch (dataType) {
				case FieldDataTypes.NUMBER:
				case FieldDataTypes.AMOUNT:
				case FieldDataTypes.DOUBLE:
					allowedOperators = [
						filterOperators.Equal,
						filterOperators.NotEqual,
						filterOperators.GreaterThan,
						filterOperators.GreaterOrEqualThan,
						filterOperators.LowerThan,
						filterOperators.LowerOrEqualTahn,
						filterOperators.Contains,
						filterOperators.StartsWith,
						filterOperators.IsBlank,
						filterOperators.IsNotBlank,
					];
					break;
				case FieldDataTypes.DATE:
				case FieldDataTypes.DATETIME:
				case FieldDataTypes.AUTOGENERATED_DATETIME:
					allowedOperators = [
						filterOperators.Equal,
						filterOperators.NotEqual,
						filterOperators.GreaterThan,
						filterOperators.GreaterOrEqualThan,
						filterOperators.LowerThan,
						filterOperators.LowerOrEqualTahn,
						filterOperators.IsBlank,
						filterOperators.IsNotBlank,
					];
					break;
				case FieldDataTypes.AUTOGENERATED_NUMBER:
					allowedOperators = [
						filterOperators.Equal,
						filterOperators.NotEqual,
						filterOperators.GreaterThan,
						filterOperators.GreaterOrEqualThan,
						filterOperators.LowerThan,
						filterOperators.LowerOrEqualTahn,
						filterOperators.Contains,
						filterOperators.StartsWith,
					];
					break;
				case FieldDataTypes.TEXT:
				case FieldDataTypes.LONG_TEXT:
				case FieldDataTypes.FILE:
				case FieldDataTypes.USER:
				case FieldDataTypes.UNIQUE_IDENTIFIER:
					allowedOperators = [
						filterOperators.Equal,
						filterOperators.NotEqual,
						filterOperators.Contains,
						filterOperators.StartsWith,
						filterOperators.IsBlank,
						filterOperators.IsNotBlank,
					];
					break;
				case FieldDataTypes.AUTOGENERATED_UNIQUEIDENTIFIER:
					allowedOperators = [
						filterOperators.Equal,
						filterOperators.NotEqual,
						filterOperators.Contains,
						filterOperators.StartsWith,
					];
					break;
				case FieldDataTypes.APPROVAL_STATUS:
				case FieldDataTypes.BOOLEAN:
					allowedOperators = [
						filterOperators.Equal,
						filterOperators.NotEqual,
						filterOperators.IsBlank,
						filterOperators.IsNotBlank,
					];
					break;
				case FieldDataTypes.AUTOGENERATED_BOOLEAN:
					allowedOperators = [
						filterOperators.Equal,
						filterOperators.NotEqual,
					];
					break;
			}
			return advancedFilterOperators.filter((x) =>
				allowedOperators.includes(x.value)
			);
		},
		valueRule() {
			if (!this.selectedColumn) return [];
			if (!this.selectedOperator) return [];
			let result = [];

			if (
				this.filter.Operator != filterOperators.IsNotBlank &&
				this.filter.Operator != filterOperators.IsBlank &&
				this.filter.Operator !=
					filterOperators.IsApprovalStatusApproved &&
				this.filter.Operator != filterOperators.IsApprovalStatusPending
			) {
				result.push(this.validations.ruleRequired(this.filter.Value));
			}

			let dataType = this.selectedColumn.DataField.DataType;
			if (
				this.selectedColumn.ReferenceListType ||
				this.selectedColumn.ReferenceListTypeId
			) {
				dataType = FieldDataTypes.TEXT;
			}

			switch (dataType) {
				case FieldDataTypes.NUMBER:
				case FieldDataTypes.DOUBLE:
				case FieldDataTypes.AMOUNT:
				case FieldDataTypes.AUTOGENERATED_NUMBER:
					result.push(
						this.validations.validateNumber(this.filter.Value)
					);
					break;
				case FieldDataTypes.AUTOGENERATED_UNIQUEIDENTIFIER:
					result.push(
						this.validations.validationUUID(this.filter.Value)
					);
					break;
				case FieldDataTypes.BOOLEAN:
				case FieldDataTypes.AUTOGENERATED_BOOLEAN:
					//result.push(this.validations.validationBoolean(this.filter.Value));
					break;
				case FieldDataTypes.DATETIME:
				case FieldDataTypes.AUTOGENERATED_DATETIME:
					result.push(
						this.validations.ruleRequired(this.dateTimeValue)
					);
					result.push(
						this.validations.validationDate(
							this.dateTimeValue,
							this.getDateTimeFormatProjectSetting()
						)
					);
					break;
				case FieldDataTypes.DATE:
					result.push(this.validations.ruleRequired(this.dateValue));
					result.push(
						this.validations.validationDate(
							this.dateValue,
							this.getDateFormatProjectSetting()
						)
					);
					break;
			}
			return result;
		},

		booleanItems() {
			return [
				{ Id: 'true', Text: 'True' },
				{ Id: 'false', Text: 'False' },
			];
		},

		approvalStatusItems() {
			return [
				{ Id: '2', Text: 'Approved' },
				{ Id: '1', Text: 'Pending' },
			];
		},
	},
	watch: {
		selectedFieldId() {
			this.onFilterChanged();
			this.selectedOperator = null;
		},
		selectedOperator() {
			this.onFilterChanged();
			this.selectedValue = null;
			this.dateTimeValue = null;
			this.dateValue = null;
		},

		selectedValue() {
			this.onFilterChanged();
		},

		dateTimeValue(newVal) {
			if (!newVal) this.filter.Value = null;
			this.selectedValue = this.convertDateTimeFormLocaleToUtc(newVal);
		},

		dateValue(newVal) {
			if (!newVal) this.filter.Value = null;
			this.selectedValue = newVal;
		},
	},

	mounted() {
		if (this.filter && this.filter.Value) {
			if (this.filterHasDateTimeValue) {
				this.dateTimeValue = this.convertDateTimeFromUtcToLocale(
					this.filter.Value
				);
			}
			if (this.filterHasDateValue) {
				this.dateValue = this.filter.Value;
			}
		}
	},
	methods: {
		convertDateTimeFromUtcToLocale(valueUtc) {
			let format = this.getDateTimeFormatProjectSetting();
			let momentutc = moment.utc(valueUtc);
			let dateStringLocale = momentutc.toLocaleString();
			let momentLocale = moment(dateStringLocale);
			let locale = momentLocale.format(format);
			return locale;
		},

		convertDateTimeFormLocaleToUtc(valueLocale) {
			let momentlocale = moment(valueLocale);
			let format = this.getDateTimeFormatProjectSetting();
			let utc = momentlocale.utc().format(format);
			return utc;
		},

		convertDateFromUtcToLocale(valueUtc) {
			let format = this.getDateFormatProjectSetting();
			let momentutc = moment.utc(valueUtc);
			let dateStringLocale = momentutc.toLocaleString();
			let momentLocale = moment(dateStringLocale);
			let locale = momentLocale.format(format);
			return locale;
		},

		convertDateFormLocaleToUtc(valueLocale) {
			let momentlocale = moment(valueLocale);
			let format = this.getDateFormatProjectSetting();
			let utc = momentlocale.utc().format(format);
			return utc;
		},
	},
};
